import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";
import { STATS } from "../../data/content";

const Counter = ({ value, prefix = "", suffix = "", noSeparator }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const reduced = useReducedMotion();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (reduced) {
      setCount(value);
      return;
    }
    const duration = 1800;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setCount(Math.round((1 - Math.pow(1 - p, 3)) * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, reduced]);

  const display = noSeparator ? String(count) : count.toLocaleString("de-DE");
  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" className="bg-[#1F2933] py-16 md:py-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
      {STATS.map((s, i) => (
        <div key={i} data-testid={`stat-item-${i}`} className="text-center lg:text-left lg:border-l lg:border-white/15 lg:pl-6 first:border-0">
          <div className="font-heading font-bold text-4xl md:text-5xl text-[#C9B79C]">
            <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} noSeparator={s.noSeparator} />
          </div>
          <p className="mt-2 text-sm text-white/70 leading-snug">{s.label}</p>
        </div>
      ))}
    </div>
  </section>
);
